// Darstellung in der Kopfleiste (partials/topbar.html.twig): hell, dunkel oder
// wie das System. Stellt die Seite sofort um und speichert die Wahl im
// Hintergrund über dasselbe Formular - der Server setzt das Cookie
// (src/Web/Theme.php), und jede weitere Seite kommt gleich in dieser
// Darstellung. Ohne JavaScript schickt das Formular ab, die Seite lädt neu.
export default function themeSwitch() {
  const forms = document.querySelectorAll('form[data-theme-switch]');
  if (!forms.length) return;
  // Speichern gescheitert (Sitzung abgelaufen, keine Verbindung): dann das
  // Formular normal abschicken, mit der Antwort des Servers.
  let native = false;

  forms.forEach(function (form) {
    form.addEventListener('submit', function (event) {
      const button = event.submitter;
      if (native || !button || button.name !== 'theme') return;
      event.preventDefault();
      apply(button.value);
      const data = new FormData(form);
      data.set(button.name, button.value);
      fetch(form.getAttribute('action'), { method: 'POST', headers: { Accept: 'application/json' }, body: data })
        .then(function (res) {
          if (!res.ok) throw new Error('HTTP ' + res.status);
          return res.json();
        })
        .then(function (body) {
          if (!body || body.theme !== button.value) throw new Error('Darstellung nicht gespeichert');
        })
        .catch(function () {
          native = true;
          form.requestSubmit(button);
        });
    });
  });

  function apply(theme) {
    document.documentElement.dataset.theme = theme;
    document.querySelectorAll('form[data-theme-switch] button[name="theme"]').forEach(function (button) {
      button.setAttribute('aria-pressed', String(button.value === theme));
    });
  }
}
